module.exports = __webpack_public_path__ + "dashboard/img/check.51befe15230a4c471f87ad8ce315454f.svg";